// @see https://github.com/microsoft/TypeScript/issues/41825
export {}
